import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  TextField,
  InputAdornment,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff, Email, Lock } from "@mui/icons-material";
import "./Login.css";
import Navbar from "../common/Navbar";
import Newfooter from "../common/NewFooter";
import SnackBar from "../common/SnackBar";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
    onClose: () => setSnackbar({ ...snackbar, open: false }),
  });

  const navigate = useNavigate();
  const location = useLocation();

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSnackbar({ open: false });

    try {
      const response = await fetch(`${BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.msg || "Login failed. Please check your credentials."
        );
      }

      const data = await response.json();
      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("role", data.employee.role);

      const params = new URLSearchParams(location.search);
      const redirect = params.get("redirect");
      navigate(redirect || "/EmployeeDashboard", { replace: true });
    } catch (error) {
      setSnackbar({
        open: true,
        severity: "error",
        message: error.message || "An error occurred. Please try again.",
        onClose: () => setSnackbar({ ...snackbar, open: false }),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="login-wrapper">
        <div className="login-left">
          <div className="vertical-wave"></div>

          <div className="login-logo">InfyU LABS HRMS</div>

          <div className="login-left-content">
            <h1 className="login-heading">Welcome Back...</h1>
            <p className="login-subtext">
              To stay connected, please log in using your personal information.
              This helps us ensure a secure and personalized experience tailored
              just for you.
            </p>
          </div>

          {/* <div className="login-footer-text">Lorem ipsum dolor sit amet</div> */}
        </div>

        <div className="login-right">
          <div className="login-card">
            <h2 className="login-title">Hello! Welcome back.</h2>
            <p className="login-subheading">Sign-in to access your account</p>
            <form onSubmit={onSubmit}>
              <TextField
                fullWidth
                required
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={onChange}
                margin="dense"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                required
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={onChange}
                margin="dense"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div className="login-options">
                <span
                  onClick={() => navigate("/forgot-password")}
                  className="forgot-link"
                >
                  Forgot password?
                </span>
              </div>

              <Button
                type="submit"
                fullWidth
                className="login-button"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Login"
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
      <SnackBar snackbar={snackbar} />
      <Newfooter />
    </>
  );
};

export default Login;
